import React, { useState } from "react";
// import "./index.css";

// components imports
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";

// images imports
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import {
  createReimburseAccount,
  resetToggle,
} from "../../../../redux/features/accounts/ReimburseAccount";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import ReimbursementAccountViewAll from "../AccountViewAll";
import ICONS from "../../../../assets/Icons";
import ConfidentialCard from "../../../../components/_utils/TransactionCommonComponents/ConfidentialCard";
import TEXT from "../../../../utils/globalText";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonLayout from "../../../../components/_utils/CommonLayout";
import { editBeneficiary } from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";

const CreateConfirm = React.memo(
  ({
    payload,
    selectedFields,
    setShowModalPopup,
    showModalPopup,
    bankUserInfo,
    recipients,
    remPan,
    setRemPan,
    manualVirtualAccount,
    type,
    bene_acc_id,
  }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const categories = useSelector(
      (state) => state.beneAllVerification.beneTransCategories.categories,
    );

    const openBeneAssociate = false;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeType, setActiveType] = useState("pan");
    const [remAccount, setRemAccount] = useState("");
    const [remIFSC, setRemIFSC] = useState("");

    const handleClick = async () => {
      if (isSubmitting) return;

      setIsSubmitting(true);
      try {
        let updatedPayload = { ...payload, navigate };
        if (
          selectedFields.length === categories.length ||
          selectedFields.length === GlobalConfiguration?.lengthCheckZero
        ) {
          updatedPayload.categories = null;
        } else {
          updatedPayload = {
            ...updatedPayload,
            categories: selectedFields.toString(),
          };
        }

        let data;
        if (type === "switch_account") {
          data = await dispatch(
            editBeneficiary({
              ...updatedPayload,
              id: bene_acc_id,
              email: updatedPayload?.email_id,
              type_of_account: "reimbursement",
            }),
          ).unwrap();
        } else {
          data = await dispatch(
            createReimburseAccount(updatedPayload),
          ).unwrap();
        }
        const accountId = data?.reimbursement_accounts?.[0].id;
        if (data?.status === true) {
          navigate(
            `/reimbursement_account_dashboard/create_reimbursement_account/success/${accountId}`,
            {
              replace: true,
              state: { type: type },
            },
          );
        }
      } catch (error) {
        navigate(
          "/reimbursement_account_dashboard/create_reimbursement_account/error",
          {
            replace: true,
            state:
              error?.response?.data?.error || error?.response?.data?.errors,
          },
        );

        return error;
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <>
        {showModalPopup && (
          <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Are you sure you want to create this account ?"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={() => {
                dispatch(resetToggle());
                setRemAccount("");
                setActiveType("pan");
                setShowModalPopup(false);
              }}
              closeicon={
                "https://q2pay.in/new_assets/common/create_flow/close.svg"
              }
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              confirmbtnrequired={true}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              ispanbankRequired={true}
              togglepan={() => {
                setActiveType("pan");
                setRemPan(payload?.panNumber);
                setRemAccount("");
                setRemIFSC("");
              }}
              toggleBank={() => {
                setActiveType("bank");
                setRemPan("");
                setRemAccount(payload?.bank_account);
                setRemIFSC(payload?.ifsc_code);
              }}
              isbottomSectionneed={true}
              bottomHeaderTextNeed={true}
              bottomHeaderText="On creating a new account, it gets added to the list of active accounts below as a 'pending' account for the PAN and Bank provided."
              btnText="Create"
              handleFunction={() => handleClick()}
            >
              <ReimbursementAccountViewAll
                id={payload.id}
                type={"ReimbursementAcc"}
                remPan={remPan}
                remAccount={remAccount}
                remIFSC={remIFSC}
                activeType={activeType}
                mainType={"create"}
                setOpenBeneAssociate={openBeneAssociate}
              />
            </LargePopupRedirect>
          </div>
        )}
        <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
          <CommonLayout>
            <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
              <div className="text-text-primary font-semibold text-font-md">
                PAN Details
              </div>
              <div className="flex flex-col gap-gap-sm">
                <div className="flex flex-col gap-gap-xs">
                  <div className="truncate capitalize font-normal text-text-primary text-font-md">
                    {payload?.panNumber}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    PAN number
                  </div>
                </div>
                <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
                <div className="flex flex-col gap-gap-xs">
                  <div className="w-width-full text-text-primary capitalize font-normal text-font-md text-wrap">
                    {payload?.legalName?.toLowerCase()}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    Legal name
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
              <div className="flex flex-col gap-gap-md">
                <div className="text-text-primary text-font-md">
                  <span className="font-semibold">GST Details</span>
                  <span className="font-normal"> (Optional)</span>
                </div>

                <div className="flex flex-col gap-gap-sm">
                  <div className="flex flex-col gap-gap-xs">
                    <div className="w-width-full overflow-hidden truncate text-text-primary capitalize font-normal text-font-md">
                      {payload.gstin ? (
                        <span>{payload.gstin}</span>
                      ) : (
                        <span>Not Given</span>
                      )}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      GSTIN
                    </div>
                  </div>
                  {payload.gstin ? (
                    <>
                      <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
                      <div className="flex flex-col gap-gap-xs">
                        <div className="w-width-full overflow-hidden text-wrap text-text-primary capitalize font-normal text-font-md">
                          {payload.gstin
                            ? payload?.gst_org_name?.toLowerCase()
                            : null}
                        </div>
                        <div className="text-font-xs font-normal text-text-secondary">
                          {payload.gstin ? "Company name" : null}
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-gap-md">
              <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-md p-padding-md">
                <div className="text-text-primary font-semibold text-font-md">
                  Bank Details
                </div>
                <div className="flex flex-col gap-gap-sm">
                  <div className="flex flex-col gap-gap-xs">
                    <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                      {formatAccountNumber(payload?.bank_account)}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      Bank account number
                    </div>
                  </div>
                  <div className="flex flex-row justify-between items-center">
                    <div className="flex flex-col gap-gap-xs">
                      <div className="text-text-primary font-normal capitalize text-font-md truncate">
                        {payload?.ifsc_code}
                      </div>
                      <div className="text-font-xs font-normal text-text-secondary">
                        IFSC code
                      </div>
                    </div>
                    <CommonBankLogo
                      ifsc={payload?.ifsc_code}
                      variant="big"
                      type="pill"
                    />
                  </div>
                  <>
                    <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
                    <div className="flex flex-col gap-gap-xs">
                      <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                        {payload?.legalName?.toLowerCase()}
                      </div>
                      <div className="text-font-xs font-normal text-text-secondary">
                        Account holder's name
                      </div>
                    </div>
                    {bankUserInfo.length >= 1 ? (
                      <>
                        <div className="flex flex-col gap-gap-xs">
                          <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                            {bankUserInfo[0].branch
                              ? bankUserInfo[0].branch
                              : "NA"}
                          </div>
                          <div className="text-font-xs font-normal text-text-secondary">
                            Branch
                          </div>
                        </div>
                        <div className="flex flex-col gap-gap-xs">
                          <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate ">
                            {bankUserInfo[0].city ? bankUserInfo[0].city : "NA"}
                          </div>
                          <div className="text-font-xs  font-normal text-text-secondary">
                            City
                          </div>
                        </div>
                        <div className="flex flex-col gap-gap-xs">
                          <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate ">
                            {bankUserInfo[0].district
                              ? bankUserInfo[0].district
                              : "NA"}
                          </div>
                          <div className="text-font-xs  font-normal text-text-secondary">
                            District
                          </div>
                        </div>
                        <div className="flex flex-col gap-gap-xs">
                          <div
                            className="w-width-full text-text-primary  font-normal capitalize  text-font-md"
                            style={{
                              textWrap: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {bankUserInfo[0].address
                              ? bankUserInfo[0].address
                              : "NA"}
                          </div>
                          <div className="text-font-xs  font-normal text-text-secondary">
                            Address
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                </div>
              </div>

              {manualVirtualAccount && (
                <div>
                  <ConfidentialCard
                    icon={ICONS.VIRTUAL_ACCOUNT}
                    title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                    note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                    toggleState={manualVirtualAccount}
                    isPreview={true}
                  />
                </div>
              )}
            </div>

            <div className="flex flex-col gap-gap-md">
              <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
                <div>
                  <div className="text-text-primary font-semibold text-font-md">
                    Contact Details
                  </div>
                </div>
                <div className="rounded-b-large flex flex-col gap-gap-md">
                  <div className=" h-height-full rounded-b-large flex flex-row">
                    <div className="flex flex-col">
                      <div className="flex flex-row items-center gap-gap-sm">
                        <div className="flex">
                          <img
                            className="w-icon-sm h-icon-sm flex-shrink-0"
                            src="https://q2pay.in/new_assets/common/create_flow/profile_unselected.svg"
                            alt="User"
                          />
                        </div>
                        <div className="w-width-full flex flex-col gap-gap-xs">
                          <div className="text-text-primary capitalize font-normal text-font-md">
                            {payload?.account_name?.toLowerCase()}
                          </div>
                          <div className="text-font-xs font-normal text-text-secondary">
                            {payload?.account_name?.toLowerCase() ===
                            payload?.legalName?.toLowerCase()
                              ? "Account name - Using legal name"
                              : "Account name"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" h-height-full rounded-b-large flex flex-row">
                    <div className="flex flex-col">
                      <div className="flex flex-row items-center gap-gap-sm">
                        <div className="flex">
                          <img
                            className="w-icon-sm h-icon-sm flex-shrink-0"
                            src="https://q2pay.in/new_assets/common/create_flow/contact_with_white_circle.svg"
                            alt="Contact"
                          />
                        </div>
                        <div className="w-width-full flex flex-col gap-gap-xs">
                          <div className="overflow-hidden truncate text-text-primary font-normal capitalize text-font-md">
                            {"+91 "}
                            {payload?.contact_no}
                          </div>
                          <div className="text-font-xs font-normal text-text-secondary">
                            Contact Number
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className=" h-height-full rounded-b-large flex flex-row">
                    <div className="flex flex-col">
                      <div className="flex flex-row items-center gap-gap-sm">
                        <div className="flex">
                          <img
                            className="w-icon-sm h-icon-sm flex-shrink-0"
                            src="https://q2pay.in/new_assets/common/create_flow/contact_us_mail.svg"
                            alt="Gmail"
                          />
                        </div>
                        <div className="w-width-full flex flex-col gap-gap-xs">
                          <div
                            id="crt-bene-acc-email-id-firstLetter"
                            className="overflow-hidden truncate text-text-primary font-normal text-font-md"
                          >
                            {linkIdentifier(payload?.email_id.toLowerCase())}
                          </div>
                          <div className="text-font-xs font-normal text-text-secondary">
                            Email ID
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
                <div className="text-text-primary text-font-md">
                  <span className="font-semibold">User</span>
                  <span className="font-normal"> (Optional)</span>
                </div>
                <div>
                  <div className="text-text-primary text-font-md">
                    {payload.userId === "" ? (
                      <div className="mb-margin-xs">Not linked</div>
                    ) : (
                      <div className="mb-margin-xs">{payload.userId}</div>
                    )}
                  </div>
                  <div className="text-text-secondary text-font-xs font-normal">
                    User
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col overflow-hidden bg-primary-card rounded-border-radius-md gap-gap-md py-padding-md w-width-full">
              <div className="px-padding-md">
                <div className="text-text-primary font-semibold text-font-md">
                  Categories
                </div>
              </div>
              <div className="overflow-auto max-h-category-popup-height px-padding-md bene-confirm-opactiy w-width-full">
                <div className="flex flex-col gap-gap-md w-width-full">
                  {selectedFields.map((categoryName, index) => (
                    <>
                      <div className="bg-primary-nav rounded-border-radius-md flex w-width-full">
                        <div className="p-padding-sm flex items-center bg-text-primary rounded-l-border-radius-md">
                          <SVGComponent url="https://q2pay.in/new_assets/web/beneficiary_category_default.svg" />
                        </div>
                        <div className="w-full flex items-center pl-padding-sm min-w-0">
                          <p className="text-text-primary truncate text-font-sm font-semibold">
                            {categoryName}
                          </p>
                        </div>
                        <div className="px-padding-sm"></div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
              <div className="text-text-primary text-font-md">
                <span className="font-semibold">Labels</span>
                <span className="font-normal"> (Optional)</span>
              </div>
              <div>
                <div className="text-text-primary text-font-md">
                  {payload?.labels?.length === 0 ? (
                    <div className="mb-margin-xs">Not assigned</div>
                  ) : (
                    <div className="mb-margin-xs">
                      {payload?.labels?.map((item, index) => (
                        <span
                          key={index}
                          className="break-all"
                        >
                          {item}
                          {index < payload.labels.length - 1 && ", "}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <div className="text-text-secondary text-font-xs font-normal">
                  Labels
                </div>
              </div>
            </div>

            <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
              <div className="text-text-primary text-font-md">
                <span className="font-semibold">Recipients</span>
                <span className="font-normal"> (Optional)</span>
              </div>
              <div>
                <div className="text-text-primary text-font-md">
                  {recipients?.length === 0 ? (
                    <div className="mb-margin-xs">Not assigned</div>
                  ) : (
                    <div className="mb-margin-xs overflow-hidden overflow-ellipsis">
                      {recipients?.map((item, index) => (
                        <span
                          key={index}
                          className="break-all"
                        >
                          {item}
                          {index < recipients?.length - 1 && ", "}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <div className="text-text-secondary text-font-xs font-normal">
                  Recipients
                </div>
              </div>
            </div>
          </CommonLayout>
        </div>
      </>
    );
  },
);

export default CreateConfirm;
